import React from 'react';

interface ReviewStatusIconProps {
  profilePhotoApproved: boolean;
  proposedProfilePhoto?: boolean;
  displayNameRejected: boolean;
  proposedDisplayName?: string;
  aboutMeRejected: boolean;
  proposedAboutMe?: string;
}

const ReviewStatusIcon: React.FC<ReviewStatusIconProps> = ({
  profilePhotoApproved,
  proposedProfilePhoto,
  displayNameRejected,
  proposedDisplayName,
  aboutMeRejected,
  proposedAboutMe,
}) => {
  const pendingItems: string[] = [];

  // Profile picture: pending only if there's a proposed photo that hasn't been approved yet
  if (proposedProfilePhoto && !profilePhotoApproved) pendingItems.push('Profile Picture');
  // Display name: pending if rejected or a new one is proposed
  if (displayNameRejected || proposedDisplayName) pendingItems.push('Display Name');
  // About me: pending if rejected or a new one is proposed
  if (aboutMeRejected || proposedAboutMe) pendingItems.push('About Me');

  const hasPendingReviews = pendingItems.length > 0;
  const statusLabel = hasPendingReviews ? `Needs review: ${pendingItems.join(', ')}` : 'All Approved';

  return (
    <div className="group relative flex items-center">
      {hasPendingReviews ? (
        <svg
          className="h-5 w-5 text-orange-500"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
      ) : (
        <svg
          className="h-5 w-5 text-green-600"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
            clipRule="evenodd"
          />
        </svg>
      )}
      <span className="invisible absolute bottom-full left-1/2 z-10 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-gray-800 px-2 py-1 text-xs text-white group-hover:visible">
        {statusLabel}
      </span>
    </div>
  );
};

export default ReviewStatusIcon;
